import { render, staticRenderFns } from "./TextEditorEmailCampaign.vue?vue&type=template&id=71569e5a&scoped=true"
import script from "./TextEditorEmailCampaign.vue?vue&type=script&lang=js"
export * from "./TextEditorEmailCampaign.vue?vue&type=script&lang=js"
import style0 from "./TextEditorEmailCampaign.vue?vue&type=style&index=0&id=71569e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71569e5a",
  null
  
)

export default component.exports